
import teamQuery from "@/apollo/queries/pages/team";
import locomotiveScrollMixin from "@/mixins/locomotiveScrollMixin";
import previewModeMixin from "@/mixins/previewModeMixin";
import {TeamMdToHtml} from '~/utils/markdown'

export default {
  name: 'team',
  colorMode: 'light',
  mixins: [locomotiveScrollMixin, previewModeMixin],
  data() {
    return {
      tlMemberOverlay: null,
      activeMemberIndex: 0,
      modalVisible: false,
      team: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$device.isDesktop) {
        // Update custom cursor position
        this.locoScroll.on('scroll', () => {
          this.$refs.CustomCursor.forEach(customCursor => {
            customCursor.$emit('loco-scroll-update');
          });
        });
      }
    });
  },
  methods: {
    triggerDetailsModal(index) {
      this.modalVisible = !this.modalVisible;

      if (this.modalVisible) {
        this.activeMemberIndex = index;

        if (this.$device.isMobile) {
          document.body.classList.add('is-nav-open');
        }

        // Get the element by its data-member-index attribute
        const referenceElement = document.querySelector(`[data-member-index="${index}"]`);

        if (referenceElement && !this.$device.isMobile) {
          const xValue = this.activeMemberIndex % 2 === 0 ? -100 : 400;
          const referenceRect = referenceElement.getBoundingClientRect();
          const topValue = `${referenceRect.top + this.locoScroll.scroll.instance.scroll.y}px`;

          this.$gsap.set(this.$refs['teamMemberModal'].$el, {
            top: topValue,
            transform: `translateX(${xValue}%)`
          });
        }

        // Set up the animation with the correct x value
        const xValue = this.activeMemberIndex % 2 === 0 || this.$device.isMobile ? 0 : "300%";
        this.setMemberOverlayAnimation(xValue);

        this.tlMemberOverlay.play().then(() => {
          // Add event listener
          document.addEventListener('click', this.handleOutsideClick);
        //   ToDo add trigger to bg doodle

        });
      } else {
        // Remove event listener
        document.removeEventListener('click', this.handleOutsideClick);

        this.tlMemberOverlay.reverse().then(() => {
          // clear the GSAP properties
          this.$gsap.set(this.$refs['teamMemberModal'].$el, {clearProps: "transform"});

          this.$refs['teamMemberModal'].$el.scrollTop = 0;
        });
        document.body.classList.remove('is-nav-open');
      }
    },
    setMemberOverlayAnimation(xValue) {
      // Check if tlMemberOverlay timeline is already initialized, if yes, kill it.
      if (this.tlMemberOverlay) {
        this.tlMemberOverlay.kill();
      }

      this.tlMemberOverlay = this.$gsap.timeline({paused: true});

      this.tlMemberOverlay.to(this.$refs['teamMemberModal'].$el, {
        x: xValue,
        duration: 0.5,
        ease: "power3.inOut",
      });
    },
    handleOutsideClick(e) {
      const modalElem = this.$refs['teamMemberModal'].$el;
      if (!modalElem.contains(e.target)) {
        this.triggerDetailsModal();
      }
    },
  },
  async asyncData({app, store}) {
    const previewMode = store.state.previewMode;

    if (previewMode) {
      await app.apolloProvider.defaultClient.resetStore();
    }

    const teamResponse = await app.apolloProvider.defaultClient.query({
      query: teamQuery,
      variables: {
        locale: app.i18n.locale,
      },
    }).catch((err) => {
      console.log(JSON.stringify(err, null, 2));
    })

    const teamData = teamResponse.data.team;

    // Process Markdown for each member description
    await TeamMdToHtml(teamData.data);

    return {
      team: teamData,
      previewMode
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
};
